import React from 'react';
import classes from "./LowBalancePage.module.css";
import Header from '../components/Header';
import { useTranslation } from 'react-i18next';
import { FaArrowLeft } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import SubLayout from '../components/SubLayout';

const LowBalancePage = () => {
    const { t } = useTranslation();
    const navigate=useNavigate();

    return (
        <>
            <Header />
            {/* <div className={classes.container}> */}

            <SubLayout style={{alignItems:"center"}}>


                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate("/");
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                </div>


                <div className={classes.info}>
                    <img
                        src="/assets/images/info.png"
                        alt="info"
                        className={classes.img}
                    />
                </div>

                <p className={classes.text}>
                    {t("108")}
                </p>
            </SubLayout>

            {/* </div> */}
        </>
    )
}

export default LowBalancePage